import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { ProfileSettingsPage } from 'features/profileSettings'

export const Route = createFileRoute('/_authenticated/_layout/profile/settings')({
  component: ProfileSettingsPage,
  head: () => ({
    meta: [
      {
        title: withCompanyName('My Profile'),
      },
    ],
  }),
})
